/** How data points are bucketed */
export type Granularity = 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'entireRange';

/** Quick-select date range presets (unified — same list for every granularity) */
export type DateRangePreset =
  | 'today'
  | 'yesterday'
  | 'thisWeek'
  | 'lastWeek'
  | 'thisMonth'
  | 'lastMonth'
  | 'thisYear'
  | 'past12Months'
  | 'thisQuarter'
  | 'lastQuarter'
  | 'last4Quarters'
  | 'custom';

/**
 * Presets for non-quarterly granularities
 */
export const DATE_RANGE_PRESETS: DateRangePreset[] = [
  'thisMonth',
  'lastMonth',
  'thisYear',
  'past12Months',
  'custom',
];

/**
 * Presets for daily granularity
 */
export const DAILY_DATE_RANGE_PRESETS: DateRangePreset[] = [
  'thisMonth',
  'lastMonth',
  'custom',
];

/**
 * Presets for quarterly granularity
 */
export const QUARTERLY_DATE_RANGE_PRESETS: DateRangePreset[] = [
  'thisQuarter',
  'lastQuarter',
  'last4Quarters',
  'custom',
];

/** Default preset when switching granularity: always "thisMonth" */
export const DEFAULT_PRESET: DateRangePreset = 'thisMonth';
export const DEFAULT_QUARTERLY_PRESET: DateRangePreset = 'thisQuarter';

/** Complete snapshot of the user's filter selection */
export interface TimeframeSelection {
  granularity: Granularity;
  preset: DateRangePreset;
  startDate: string; // YYYY-MM-DD
  endDate: string;   // YYYY-MM-DD
}
